Wee.fn.make('accordion', {
	init: function() {
		this.$private.accordion();
	}
}, {
	/**
	* Click event to fire panel toggling
	*
	* @private
	*/
	accordion: function() {
		var $toggle = $('ref:dropParent'),
			isActive = ('-is-active');

		$toggle.on('click.mobile', function() {
			var $this = $(this);

			if ($this.hasClass(isActive)) {
				$this.deActivate();
				$this.next().deActivate().hide();
			} else {
				$this.activate();
				$this.next().activate().show();
			}
		});
	}
});